import {Component, OnDestroy} from '@angular/core';
import {UntypedFormBuilder, Validators} from '@angular/forms';
import {AuthService} from '../../services/auth.service';
import {PasswordFieldIconType} from '../../../../core/interfaces/password-field-icon-type';
import {PasswordFieldType} from '../../../../core/interfaces/password-field-type';
import {RegisterData} from '../../../../core/interfaces/register-data';
import {passwordMatchValidator} from '../../../../core/interfaces/password-match-validator';
import {EMPTY, Subject} from 'rxjs';
import {catchError, takeUntil, tap} from 'rxjs/operators';
import {MatDialogRef} from '@angular/material/dialog';
import {LoginAndRegDialogComponent} from '../login-and-reg-dialog/login-and-reg-dialog.component';
import {NotificationService} from '../../../../core/services/notification.service';
import {TranslateService} from '@ngx-translate/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnDestroy {
  private unsubscribe$ = new Subject<void>();

  public form = this.formBuilder.group({
    login: [null, [Validators.required]],
    password: [null, [Validators.required, Validators.minLength(4), Validators.maxLength(50)]],
    confirmPassword: [null, [Validators.required]],
    email: [null, [Validators.required, Validators.minLength(5), Validators.email]],
    captchaResp: [null],
  }, {
    validator: passwordMatchValidator('password', 'confirmPassword')
  });

  public isShowPassword = false;
  public isShowConfirmPassword = false;
  public environment = environment;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly authService: AuthService,
    private readonly matDialogRef: MatDialogRef<LoginAndRegDialogComponent>,
    private readonly notificationService: NotificationService,
    private readonly translateService: TranslateService,
  ) {}

  public passwordFieldType(value: boolean): PasswordFieldType {
    return value ? 'text' : 'password';
  }

  public iconName(value: boolean): PasswordFieldIconType {
    return value ? 'visibility' : 'visibility_off';
  }

  public changePasswordVisibility(): void {
    this.isShowPassword = !this.isShowPassword;
  }

  public changeConfirmPasswordVisibility(): void {
    this.isShowConfirmPassword = !this.isShowConfirmPassword;
  }

  public formErrorHandler(control: keyof RegisterData, error: string): boolean | undefined {
    return this.form.get(control)?.hasError(error);
  }

  public getTranslatedText(key: string): string {
    return this.translateService.instant(key);
  }

  public resolveCaptcha(event: unknown): void {
    this.form.get('captchaResp').setValue(event);
  }
  public submit(): void {
    const registerData = this.form.getRawValue();

    this.authService.registration(registerData).pipe(
      tap( () => {
        this.notificationService.openSuccessMessage(this.getTranslatedText('authorization.success.registration'));
        this.matDialogRef.close();
      }),
      catchError( error => {
        this.notificationService.openErrorMessage(error.error);
        return EMPTY;
      }),
      takeUntil(this.unsubscribe$),
    ).subscribe();
  }

  public ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
